import { DatePipe } from "@angular/common";
import { HistoryItem } from "@core/models/shared/history.model";

/** loop over history items and format any DateTime values */
export function FormatHistoryItemsDateTime(
	historyItems: HistoryItem[] | HistoryItem[],
	datePipe: DatePipe): void {
	historyItems?.forEach(item => {
		// dateTime values coming from the stored proc are in 
		// the format '2/26/2025 9:22:40 PM +00:00'
		const pattern = /(\d{1,2})\/(\d{1,2})\/(\d{4}) (\d{1,2}):(\d{2}):(\d{2}) (AM|PM) ([+-]\d{2}:\d{2})/;
		const newValIsDateTime = item.newValue?.match(pattern);
		const prevValIsDateTime = item.previousValue?.match(pattern);
		if (newValIsDateTime) {
			item.newValue = datePipe.transform(new Date(item.newValue), 'MM/dd/yyyy h:mm a');
		}
		if (prevValIsDateTime) {
			item.previousValue = datePipe.transform(new Date(item.previousValue), 'MM/dd/yyyy h:mm a');
		}
	});
}